module.exports = __webpack_public_path__ + "img/contact-icon.98ce7245.svg";